import {OffsetPositionByPlatform} from '@gongxigames/framework/core';

export const counterOffsets: OffsetPositionByPlatform = {
    desktop: {
        x: 0, y: 900
    },
    mobile: {
        landscape: {x: 30, y: 800},
        portrait: {x: 240, y: 2780}
    }
};
